module.exports = __webpack_public_path__ + "img/bb_g3_antenna-01.db2b4662.svg";